import React from "react";
import "./OperatorProfile.css";

const OperatorProfile = () => {
  const completedObjectives = [
    "WEB_EXPLOITATION_CHALLENGE_01",
    "CRYPTOGRAPHIC_PUZZLE_ALPHA",
    "REVERSE_ENGINEERING_BETA",
    "FORENSICS_INVESTIGATION_GAMMA",
    "SQL_INJECTION_MASTER",
    "BUFFER_OVERFLOW_EXPLOIT",
    "STEGANOGRAPHY_HIDDEN_FLAG",
    "NETWORK_PACKET_ANALYSIS",
    "BINARY_EXPLOITATION_DELTA",
  ];

  return (
    <div className="operator-profile">
      <div className="profile-header">
        <h1>//PLAYER_PROFILE</h1>
      </div>

      <div className="profile-content">
        <div className="unit-identification">
          <h2>//TEAM IDENTIFICATION</h2>
          <div className="unit-info">
            <div className="unit-logo-section">
              <div className="unit-logo"></div>
              <div className="logo-label">TEAM_LOGO</div>
            </div>
            <div className="unit-details">
              <div className="callsign">TEAM: CYBER_PHOENIX</div>
              <div className="operatives-section">
                <span className="operatives-label">MEMBERS:</span>
              </div>
              <div className="operatives-list">
                <div className="operative-item">
                  [M-01] Captain "GHOST" Sharma
                </div>
                <div className="operative-item">
                  [M-02] Lieutenant "RESOLVER" Carter
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="completed-objectives">
          <h2>//COMPLETED_CHALLENGES</h2>
          <div className="objectives-grid">
            {completedObjectives.map((objective, index) => (
              <div key={index} className="objective-card">
                <div className="objective-text">{objective}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="comms-link">
          <h2>TEAM_INVITATION_LINK</h2>
          <div className="link-container">
            <div className="comms-url">
              https://phoenix-cybersecurity.com/ctf/invite/CYBER_PHOENIX_X9K2M
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperatorProfile;
